export default __webpack_public_path__ + "static/media/underdog.3ab24213.png";